module.exports = __webpack_public_path__ + "fonts/icofont.50a4ab76.woff2";